//import liraries
import React, { useEffect, useState } from "react";
import { View, Dimensions,} from "react-native";
import Transfer_PoolToTag from "./Transfer_PoolToTag";
import { getPoolAccountdetail } from "../../api/apiManager";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import MobileHeader from "../../common/MobileHeader";
import TabHeader from "../../common/TabHeader";
import { Outlet, useLocation } from "react-router-dom";
import useStyles from "./PoolAccount_Home_Styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const PoolToTag_Home = (props) => {
  const styles = useStyles();
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [selectedLayout, setSelectedLayout] = useState("Transfer Pool");
  const [selectedValue, setSelectedValue] = useState("");
  const [data, setData] = useState({});
  const [maskedAccNum, setMaskedAccNum] = useState("");
  const location = useLocation();
  const currentPath = location.pathname.split("/")[2];
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedLayout == "Pool Home") {
      getPoolAccountDtls();
    }
  }, [selectedLayout]);

  const getMaskedNum = (string) => {
    var new_string = string.replace(
      /\b[\dX][-. \dX]+(\d{4})\b/g,
      function (match, capture) {
        return Array(match.length - 4).join("X") + capture;
      }
    );
    return new_string;
  };

  useEffect(() => {
    setSelectedLayout(props?.route?.params);
  }, [props?.route?.params]);
  console.log(props, "props. pool home");

  const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
        setData(res || {});
        setMaskedAccNum(getMaskedNum(res?.accountNo || ""));
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <View>
      <Header />
      <MobileHeader isShowSidebar={setIsShowSidebar} />
      <TabHeader />
      <View style={styles.contentWrapper}>
        <View style={styles.contentWidget}>
          {!isShowSidebar && <Sidebar navigation={props.navigation} />}
          <View style={styles.sideContentWidget}>
            {currentPath != undefined ? (
              <Outlet />
            ) : (
              <Transfer_PoolToTag
                selectedValue={(value) => setSelectedValue(value)}
                navigation={props.navigation}
                setSelectedLayout={(layout) => setSelectedLayout(layout)}
              />
            )}
          </View>
        </View>
      </View>
    </View>
  );
};



//make this component available to the app
export default PoolToTag_Home;
